<template>
    <div>
        <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
            :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
    </div>
</template>

<script>
export default {
    data() {
        return {
            uploadUrl: "http://192.168.0.129:8081/sw-api/upload/uploadImg", // 上传的图片服务器地址
            // uploadUrl: "https://www.mssbaby.com/sw-api/upload/uploadImg", // 上传的图片服务器地址
            imageUrl: ''
        };
    },
    created() { },
    methods: {
        handleAvatarSuccess(res, file) {
            console.log(res,file,'res=============')
            this.imageUrl = res.data
        },
        beforeAvatarUpload(file) {
            // const isJPG = file.type === 'image/jpeg';
            // const isLt2M = file.size / 1024 / 1024 < 2;

            // if (!isJPG) {
            //     this.$message.error('上传头像图片只能是 JPG 格式!');
            // }
            // if (!isLt2M) {
            //     this.$message.error('上传头像图片大小不能超过 2MB!');
            // }
            // return isJPG && isLt2M;
        }
    }
};
</script>
<style scoped lang="scss">
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #000;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
    background: #8c939d;

}

.avatar {
    background: #8c939d;
    width: 130px;
    height: 130px;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/superadmin/StoreFrontAudit/elUpload.vue